const RESULTS_PATH = '/result';

/** Statuses with no WHOIS record to show → redirect to the results page. */
const RESULTS_PAGE_STATUSES = new Set(['purchase', 'notSupportedTld', 'notSupportedTldRegional']);

/** Search-results URL for a query. Shared by the search bar and the redirect. */
export const buildResultsUrl = query => `${RESULTS_PATH}?query=${encodeURIComponent(query)}`;
/**
 * Results URL to redirect to (available domain or unsupported TLD), else `null`.
 * The `!isLoading` guard avoids a stale status mid-lookup — the suite's status
 * store isn't reset between in-page re-submits.
 */
export const resolveWhoisRedirect = _ref => {
  let domain = _ref.domain,
    isLoading = _ref.isLoading,
    actionStatus = _ref.actionStatus,
    errorStatus = _ref.errorStatus;
  if (!domain) {
    return null;
  }
  const shouldRedirect = !isLoading && !!actionStatus && RESULTS_PAGE_STATUSES.has(actionStatus) || errorStatus === 404;
  return shouldRedirect ? buildResultsUrl(domain) : null;
};
//# sourceMappingURL=whoisRedirect.js.map